import { Dispatch, SetStateAction } from 'react'
import toast from 'react-hot-toast'
import { NodeProps } from 'reactflow'
import { translations } from '../../../configs/translations'
import { useStore } from '../../../store/store'
import './ModulesContent.css'

export interface ModulesContentProps {
	isBought: boolean,
	isResearched: boolean,
	isParentBoughtOrResearched: boolean,
	experience?: number,
	price?: number,
	xpPrice?: number,
	setTriggerUpdate: Dispatch<SetStateAction<number>>,
	onClick: () => Promise<void>,
	onPreview: () => Promise<void>
}

const ActiveButton = (
	{ text, type, onClick }: {
		text: string,
		type: 'BUY' | 'RESEARCH' | 'AQUIRED' | 'PREVIEW',
		onClick: () => void
	}
) => {
	return (
		<div>
			<div
				className={`modules-content-button ${type}`}
				onClick={onClick}
			>
				{text}
			</div>
		</div>
	)
}

const ModulesContentBuy = (
	{ onClick, onPreview, t, price }: {
		onClick: () => void,
		onPreview: () => void,
		t: typeof translations[keyof typeof translations],
		price: number | undefined
	}
) => {
	return (
		<div>
			<div className="modules-content-text">
				<div className='module-content-text-amount'>
					<img src="/icons/32px/money.png" alt="money" />
					<p>{price || 0}</p>
				</div>
			</div>
			<div className='modules-content-buttons'>
				<ActiveButton
					text={t.buy}
					type="BUY"
					onClick={onClick}
				/>
				<ActiveButton
					text={t.car_overview}
					type="PREVIEW"
					onClick={onPreview}
				/>
			</div>
		</div>
	)
}

const ModulesContentResearch = (
	{ onClick, onPreview, t, xpPrice }: {
		onClick: () => void,
		onPreview: () => void,
		t: typeof translations[keyof typeof translations],
		xpPrice: number | undefined
	}
) => {
	return (
		<div>
			<div className="modules-content-text">
				<div className='module-content-text-amount'>
					<img src="/icons/32px/xp.png" alt="experience" />
					<p>{xpPrice || 0}</p>
				</div>
			</div>
			<div className='modules-content-buttons'>
				<ActiveButton
					text={t.to_research}
					type="RESEARCH"
					onClick={onClick}
				/>
				<ActiveButton
					text={t.car_overview}
					type="PREVIEW"
					onClick={onPreview}
				/>
			</div>
		</div>
	)
}

const ModulesContentAquired = (
	{ onClick, onPreview, t, experience }: {
		onClick: () => void,
		onPreview: () => void,
		t: typeof translations[keyof typeof translations],
		experience: number | undefined
	}
) => {
	return (
		<div>
			<div className='modules-content-buttons'>
				<ActiveButton
					text={t.show_in_garage}
					type="AQUIRED"
					onClick={onClick}
				/>
				<ActiveButton
					text={t.car_overview}
					type="PREVIEW"
					onClick={onPreview}
				/>
			</div>
			<div className="modules-content-text">
				<div className='module-content-text-amount'>
					<img src="/icons/32px/xp.png" alt="experience" />
					<p>{experience || 0}</p>
				</div>
				<p>{t.race_experience}</p>
			</div>
		</div>
	)
}

export const ModulesContent = ((props: NodeProps<ModulesContentProps>) => {
	const { isBought, isResearched, isParentBoughtOrResearched, experience, price, xpPrice, setTriggerUpdate, onClick, onPreview } = props.data
	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	const handleClick = () => {
		onClick()
			.then(() => setTriggerUpdate((prev: number) => prev + 1))
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	const handlePreview = () => {
		onPreview()
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	const getContent = () => {
		if (isBought) return ModulesContentAquired({
			onClick: handleClick,
			onPreview: handlePreview,
			t,
			experience
		})
		if (isResearched) return ModulesContentBuy({
			onClick: handleClick,
			onPreview: handlePreview,
			t,
			price
		})
		if (isParentBoughtOrResearched && !isBought) return ModulesContentResearch({
			onClick: handleClick,
			onPreview: handlePreview,
			t,
			xpPrice
		})
	}

	return (
		<div>
			{getContent()}
		</div>
	)
})